import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import referralAssocGroupStyles from '../assets/jss/crm/components/referralAssocGroupStyles';

import DA from '../store/ReduxAccess';

import ReferralCategoryGroup from './ReferralCategoryGroup';

class ReferralAssocGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showReferralCategoryGroups: false,
    };
  }

  toggleReferralsVisibility() {
    this.setState({ showReferralCategoryGroups: !this.state.showReferralCategoryGroups });
  }

  createReferralsCategoryGroups(referrals) {
    const sortedReferrals = this.createReferralsListAugmentedWithStatus(referrals);

    const prospectReferrals = sortedReferrals.filter((referral) => referral.status === 'Prospect');
    const clientReferrals = sortedReferrals.filter((referral) => referral.status === 'Client');
    const alumniReferrals = sortedReferrals.filter((referral) => referral.status === 'Alum');

    return (
      <div>
        <ReferralCategoryGroup label="Prospect" referrals={prospectReferrals} />
        <ReferralCategoryGroup label="Client" referrals={clientReferrals} />
        <ReferralCategoryGroup label="Alumni" referrals={alumniReferrals} />
      </div>
    );
  }

  sort(referrals) {
    return referrals.sort((r1, r2) => r2.contactDate - r1.contactDate);
  }

  createReferralsListAugmentedWithStatus(referrals) {
    const sortedReferrals = this.sort(referrals);
    const augmentedReferrals = sortedReferrals.map((referral) => {
      if (referral.status) {
        return referral;
      } else {
        const referree = DA.getPersonById(referral.referreeId);
        return {
          ...referral,
          status: referree.status,
        };
      }
    });
    return augmentedReferrals;
  }

  render() {
    let { classes, referrals } = this.props;
    referrals = referrals || [];
    return (
      <div className={classes.entityAssocGroup}>
        <div className={classes.entityAssocGroup_header} onClick={() => this.toggleReferralsVisibility()}>
          <div className={classes.entityAssocGroup_title + ' ' + classes.ac_h4}>
            Referrals ({referrals.length})&nbsp;
            {referrals.length ? (
              <i
                className={cx(
                  classes.entityAssocGroup_expand,
                  'zmdi',
                  { 'zmdi-chevron-right': !this.state.showReferralCategoryGroups },
                  { 'zmdi-chevron-down': this.state.showReferralCategoryGroups }
                )}
              />
            ) : null}
          </div>
        </div>
        {this.state.showReferralCategoryGroups && this.createReferralsCategoryGroups(referrals)}
      </div>
    );
  }
}

export default withStyles(referralAssocGroupStyles)(ReferralAssocGroup);
